import React from "react";
import { Box, Typography } from "@mui/material";
import { SpecsInputField } from "./SpecsEditorFields/index";
import {
  BooleanField,
  ColorCombosField,
  DisplayMethodField,
  SilentMigrationField,
  StringMultiSelectField,
} from "./SpecsLayerSpecsControls";
import SpecsNumberField from "./specsForm/SpecsNumberField";
import type { StyleModel } from "./specsModel/StyleModel";

export function SpecsLayerSpecsStyleFields({
  style,
  styleOptions,
  debugPath,
}: {
  style: StyleModel;
  styleOptions: string[];
  debugPath?: string;
}) {
  return (
    <Box>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Style
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
          gap: 2,
        }}
      >
        <SpecsNumberField
          label="Credits"
          value={style.credits}
          debugPath={debugPath ? `${debugPath}.credits` : undefined}
          onChange={(value) => {
            style.credits = value ?? 0;
          }}
        />
        <DisplayMethodField
          label="Display method"
          debugPath={debugPath ? `${debugPath}.displayMethod` : undefined}
          value={style.displayMethod}
          onChange={(value) => {
            style.displayMethod = value;
          }}
        />
        <SpecsInputField
          label="Migrate to"
          debugPath={debugPath ? `${debugPath}.migrateTo` : undefined}
          value={style.migrateTo}
          onChange={(event) => {
            style.migrateTo = event.target.value;
          }}
        />
        <SpecsInputField
          label="Pattern"
          debugPath={debugPath ? `${debugPath}.pattern` : undefined}
          value={style.pattern}
          onChange={(event) => {
            style.pattern = event.target.value;
          }}
        />
        <SpecsInputField
          label="Pattern text color"
          debugPath={debugPath ? `${debugPath}.patternTextColor` : undefined}
          value={style.patternTextColor}
          onChange={(event) => {
            style.patternTextColor = event.target.value;
          }}
        />
        <BooleanField
          label="Disabled"
          debugPath={debugPath ? `${debugPath}.disabled` : undefined}
          checked={style.disabled}
          onChange={(checked) => {
            style.disabled = checked;
          }}
        />
        <BooleanField
          label="Use color combo"
          debugPath={debugPath ? `${debugPath}.useColorCombo` : undefined}
          checked={style.useColorCombo}
          onChange={(checked) => {
            style.useColorCombo = checked;
          }}
        />
        <BooleanField
          label="Prevent color duplicates"
          debugPath={
            debugPath ? `${debugPath}.preventColorDuplicates` : undefined
          }
          checked={style.preventColorDuplicates}
          onChange={(checked) => {
            style.preventColorDuplicates = checked;
          }}
        />
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 2fr" },
          gap: 2,
          mt: 2,
        }}
      >
        <StringMultiSelectField
          label="Disabling when selected"
          debugPath={
            debugPath ? `${debugPath}.disablingWhenSelected` : undefined
          }
          value={style.disablingWhenSelected}
          options={styleOptions.filter((option) => option !== style.name)}
          onChange={(value) => {
            style.disablingWhenSelected = value;
          }}
          placeholder="Select styles"
        />
        <Box>
          <SilentMigrationField
            label="Silent migration"
            debugPath={debugPath ? `${debugPath}.silentMigration` : undefined}
            value={style.silentMigration}
            styleOptions={styleOptions}
            onChange={(value) => {
              style.silentMigration = value;
            }}
          />
        </Box>
        <Box sx={{ gridColumn: "1 / -1" }}>
          <ColorCombosField
            label="Color combos"
            debugPath={debugPath ? `${debugPath}.colorCombos` : undefined}
            value={style.colorCombos}
            layers={style.layers.map((layer) => layer.name)}
            onChange={(value) => {
              style.colorCombos = value;
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
